import Pusher from 'pusher-js';
import {env} from "./EnvironmentConfig"

const PusherNotifications = new Pusher(env.PUSHER_APP_KEY, {
    cluster: env.PUSHER_APP_CLUSTER,
});

export default PusherNotifications
